module.exports = __webpack_public_path__ + "static/media/im_loading.cf4a8a5c.svg";